export default __webpack_public_path__ + "static/media/mw12.81124e47.webp";